import Card from "@/components/custom/card";
import { Mixpanel } from "@/lib/mixpanel";
import { Account, Currency } from "@/lib/types";
import { currencyFormatter } from "@/lib/utils";
import { useMemo } from "react";
import { useNavigate } from "react-router-dom";

const CardItem = ({
  item,
  currencies,
}: {
  item: Account & { icon: React.ReactNode };
  currencies: Currency[];
}) => {
  const navigate = useNavigate();
  const currentCurrency = useMemo(() => {
    return currencies.find((currency) => currency.id === item.currencyId);
  }, [currencies, item.currencyId]);

  return (
    <Card
      onClick={() => {
        navigate(`/balance/${item.id}`);
        Mixpanel.track("Balance Card Clicked");
      }}
      className="flex items-center justify-between gap-3 px-[15px] py-[14px]"
      data-testid={`card-item-${item.id}`}
    >
      <div className="flex items-center gap-3">
        <CardIcon icon={item.icon} />
        <div className="flex flex-col justify-center gap-2">
          <span className="text-[15px] font-medium leading-4 text-white">
            {item.name}
          </span>
          <span className="text-[15px] font-medium leading-4 text-white/[66%]">
            {item.accountNumber}
          </span>
        </div>
      </div>

      <span className="text-[15px] font-medium leading-4 text-[#7ECEE8]">
        {currencyFormatter(item.currentBalance, currentCurrency?.code)}
      </span>
    </Card>
  );
};

const CardIcon = ({ icon }: { icon: React.ReactNode }) => {
  return (
    <div className="flex h-10 w-[55px] items-center justify-center rounded-md bg-[url('/images/icon-bg.png')] bg-contain bg-center bg-no-repeat text-white shadow-[0px_1px_3px_0px_rgba(0,0,0,0.7)]">
      {icon}
    </div>
  );
};

export default CardItem;
